var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"word-container"},[_c('h2',[_vm._v(_vm._s(_vm.word))]),(this.hasLetters)?_c('div',{staticClass:"delete",on:{"click":function($event){return _vm.clearWord()}}},[_vm._v("X")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }